import $ from "jquery";
import {$body} from '../../../Constants';
import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Technical Data
 */
const TechnicalData = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		TECHNICAL_DATA: '.technical-data',
		SHEET: '.technical-data-sheet',
		MORE: '.technical-data-more'
	};

	/**
	 * Technical Data
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class TechnicalData extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();
			this._isExpanded = false;
			this._sheets = this.$element.find(Selector.SHEET);

			if (this._sheets.length >= 3) {
				this._initialize();
			}
		}

		_initialize() {
			this.$element.find(Selector.MORE).on('click', (e) => {
				const offset = window.pageYOffset;
				const $icon = $(e.currentTarget).find('i');
				this.$element.toggleClass('expanded', !this._isExpanded);
				$icon.toggleClass('fa-minus', !this._isExpanded);
				$icon.toggleClass('fa-plus', this._isExpanded);
				this._isExpanded = !this._isExpanded;
				window.scrollTo(0, offset);
			});
		}
	}

	return TechnicalData._getElement($body.find(Selector.TECHNICAL_DATA), TechnicalData);
})();

export default TechnicalData;
